package com.shmbles.web.models

import com.shmbles.web.util.Res

enum class Company(
    val logo: String,
    val companyName: String,
    val role: String,
    val darkBackground: Boolean = false
) {
    Pulppo(
        logo = Res.Image.pulppo,
        companyName = "Pulppo",
        role = "Android Developer"
    ),
    Kastech(
        logo = Res.Image.kastech,
        companyName = "Kastech",
        role = "Android Developer"
    ),
    Backbase(
        logo = Res.Image.backbase,
        companyName = "Backbase",
        role = "Android Developer"
    ),
    Bineo(
        logo = Res.Image.bineo,
        companyName = "Bineo",
        role = "Android Developer",
        darkBackground = true
    ),
    MercadoLibre(
        logo = Res.Image.mercadolibre,
        companyName = "MercadoLibre",
        role = "Software Engineer"
    )
}
